import { createContext } from 'react'

// eslint-disable-next-line @typescript-eslint/no-empty-function
const ThemeContexts = createContext(['light', () => {}])

export default ThemeContexts
